import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-foreground-900">
              Sugargoo <span className="text-primary-600">Spread</span>
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              Your ultimate resource hub for Sugargoo Spreadsheet finds, shopping guides, and product categories. Helping shoppers discover organized products since 2026.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-800 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-review" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Sugargoo Review
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-beginners-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Beginners Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Visit Main Site
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-800 mb-4">Shopping Guides</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/sugargoo-shipping-cost" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Shipping Cost Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-coupon-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Coupon &amp; Discounts
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-warehouse-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Warehouse Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-qc-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  QC Photo Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-tips-tricks" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Tips &amp; Tricks
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-800 mb-4">Browse Categories</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Hoodies &amp; Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Accessories
                </a>
              </li>
              <li>
                <Link to="/best-sugargoo-finds" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                  Best Finds
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Sugargoo Spread. All rights reserved. This is an independent resource website.
          </p>
          <p className="text-xs text-foreground-400">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-600 transition-colors">
              Visit Main Website
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}